// extracted by mini-css-extract-plugin
export default {"root":"BurgerButton_root__F6XWp","opened":"BurgerButton_opened__WPqVL"};